import React, { Component } from 'react';
import classNames from 'classnames';

class ToolTip extends Component {
  constructor(props) {
    super(props);
    this.timeout = null;
  }

  state = {
    showTooltip: null
  }

  handleClick = (e) => {
    e.preventDefault();
    const { tooltipActiveInMs } = this.props;
    if (this.timeout) {
       clearTimeout(this.timeout);
       window.removeEventListener('click', clearTooltip);
    }

    const clearTooltip = () => {
      clearTimeout(this.timeout);
      this.setState({ showTooltip: false });
      window.removeEventListener('click', clearTooltip);
    };

    this.setState({ showTooltip: true }, () => {
      window.setTimeout(() => {
        window.addEventListener('click', clearTooltip);
      }, 500);
    });

    this.timeout = setTimeout(() => {
      this.setState({ showTooltip: false });
      window.removeEventListener('click', clearTooltip);
    }, tooltipActiveInMs);
  }

  render() {
    const { children, tooltipMsg } = this.props;
    const { showTooltip } = this.state;

    const tooltipMsgClasses = classNames('lc-pf-tooltip-msg', {
      'lc-pf-tooltip-msg--show': showTooltip,
      'lc-pf-tooltip-msg--hide': showTooltip === false
    });

    return <div className='lc-pf-tooltip'>
      <a onClick={this.handleClick} className='lc-pf-tooltip-body'>{children}</a>
      <div className={tooltipMsgClasses}>
        <div className='lc-pf-tooltip-arrow-up' />
        <span>{tooltipMsg}</span>
      </div>
    </div>;
  }
}

ToolTip.defaultProps = {
  tooltipActiveInMs: 500
};

export default ToolTip;



